import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { FileParameter } from '../../services/ppv.api'
import { CsvFileType, UploadCsvEvent } from '../../models/csv/validate-csv'
import { FileUpload } from 'primeng/fileupload'

interface FileError {
   index: string
   message: string
}

@Component({
   selector: 'vc-file-upload',
   templateUrl: './file-upload.component.html',
   styleUrl: './file-upload.component.scss',
   standalone: false,
})
export class FileUploadComponent {
   @Input() accept: string = 'text/*'
   @Input() isSubmitting = new BehaviorSubject<boolean>(false)
   @Input() isValidating = new BehaviorSubject<boolean>(false)
   @Input() errorMessages = new BehaviorSubject<FileError[]>([])
   @Input() warningMessages = new BehaviorSubject<FileError[]>([])
   @Input() multiple: boolean = false
   @Output() onUpload = new EventEmitter<UploadCsvEvent>()
   @Output() onSelectFile = new EventEmitter<FileParameter>()
   @Output() onCancel = new EventEmitter<void>()

   @ViewChild('fileUpload') fileUpload: FileUpload

   uploadedFiles = new BehaviorSubject<any[]>([])

   constructor() {
      this.isSubmitting.subscribe((isSubmitting) => {
         console.log('isSubmitting changed:', isSubmitting)
      })
   }

   onFileSelect(event: any) {
      if (!this.multiple) {
         this.errorMessages.next([])
         this.warningMessages.next([])
      }
      if (event.files && event.files.length > 0) {
         this.uploadedFiles.next(event.currentFiles)
         var selectedFile = event.files[0]
         const fileParameter: FileParameter = {
            data: selectedFile,
            fileName: selectedFile.name,
         }
         this.onSelectFile.emit(fileParameter)
      }
   }

   upload() {
      this.isSubmitting.next(true)
      const fileParameters: FileParameter[] = []
      for (let file of this.uploadedFiles.value) {
         const fileParameter = {
            data: file,
            fileName: file.name,
         }
         fileParameters.push(fileParameter)
      }
      this.onUpload.emit({ fileParameters, isSubmitting: this.isSubmitting.value, fileType: null })
   }

   onFileRemove(event: { originalEvent: PointerEvent; file: File }) {
      this.errorMessages.next(this.errorMessages.value.filter((errMess) => errMess.index !== event.file.name))
      this.warningMessages.next(this.warningMessages.value.filter((errMess) => errMess.index !== event.file.name))
   }

   onClear() {
      this.errorMessages.next([])
      this.warningMessages.next([])
      this.uploadedFiles.next([])
   }

   hasError(file: any): boolean {
      return this.errorMessages.value.some((errMess) => errMess.index === file.name)
   }

   disableUploadButton(): boolean {
      return this.isSubmitting.value || this.isValidating.value || this.uploadedFiles.value.length === 0 || this.errorMessages.value.length > 0
   }

   disableChooseButton(): boolean {
      return this.isValidating.value || this.isSubmitting.value
   }

   onCancelAction() {
      this.fileUpload.clear()
      this.onClear()
      this.onCancel.emit()
   }
}
